const LOCATION_PERMISSION_EXPLAINED_KEY = "driver_location_permission_explained";
const PUSH_PERMISSION_EXPLAINED_KEY = "driver_push_permission_explained";
const DRIVER_LANGUAGE_KEY = "driver_language";

const permissionCopy = {
  ja: {
    location: "ステータス更新時に現在地を記録し、配車担当が運行状況を確認できるようにします。位置情報の利用を許可してください。",
    push: "通知を有効にすると、新しい配車や予約変更をすぐに確認できます。通知を許可してください。",
  },
  en: {
    location: "Your location is recorded when you update an order status so dispatch can confirm service progress. Please allow location access.",
    push: "Enable notifications to receive new assignments and order changes promptly. Please allow notifications.",
  },
  zh_cn: {
    location: "更新订单状态时会记录当前位置，方便调度确认服务进度。请允许定位权限。",
    push: "开启通知后，新的派单和订单变更会及时提醒你。请允许通知权限。",
  },
  zh_tw: {
    location: "更新訂單狀態時會記錄目前位置，方便調度確認服務進度。請允許定位權限。",
    push: "開啟通知後，新的派單和訂單變更會即時提醒你。請允許通知權限。",
  },
};

function getPermissionCopy() {
  try {
    const language = localStorage.getItem(DRIVER_LANGUAGE_KEY) || "zh_cn";
    return permissionCopy[language === "zh" ? "zh_cn" : language] || permissionCopy.zh_cn;
  } catch {
    return permissionCopy.zh_cn;
  }
}

function hasSeen(key) {
  try {
    return localStorage.getItem(key) === "1";
  } catch {
    return false;
  }
}

function markSeen(key) {
  try {
    localStorage.setItem(key, "1");
  } catch {
    // Best effort only.
  }
}

function confirmOnce(key, message) {
  if (hasSeen(key)) return true;
  const accepted = window.confirm(message);
  if (accepted) markSeen(key);
  return accepted;
}

export function explainLocationPermissionOnce() {
  return confirmOnce(
    LOCATION_PERMISSION_EXPLAINED_KEY,
    getPermissionCopy().location
  );
}

export function explainPushPermissionOnce() {
  return confirmOnce(
    PUSH_PERMISSION_EXPLAINED_KEY,
    getPermissionCopy().push
  );
}
